import { type FunctionComponent } from 'react'
import { Box } from '@instacart/ids-core'
import { Text } from '@retailer-platform/shared-components/src/tds'
import { colors } from '@retailer-platform/shared-components'

interface StoreMarkerProps {
  name: string
}

const StoreMarker: FunctionComponent<StoreMarkerProps> = ({ name }) => (
  <Box
    css={{
      display: 'inline-flex',
      alignItems: 'center',
      backgroundColor: colors.PRIMARY_TDS.LIGHT,
      borderRadius: '4px',
      padding: '2px 6px',
    }}
  >
    <Text typography="accentEmphasized" css={{ color: colors.PRIMARY_TDS.DARK }}>
      {name}
    </Text>
  </Box>
)

export default StoreMarker
